/**
 * Total TTC d'une commande : transport + manutention.
 *
 * Même formule que la facturation — AdminBillingController et
 * DonneesFactureMensuelleService composent tous deux
 * `sum('TTC') + sum('manutention_total_ttc')`. Les deux colonnes sont disjointes
 * en base : `TTC` vaut `livraisonHT × 1,20`, le transport seul, et la
 * manutention est écrite séparément. Les additionner ne compte rien deux fois.
 *
 * `TTC` est déjà net de la remise promo, donc ce total est bien le montant
 * facturé.
 */
export const totalTtcCommande = (commande) =>
  Number(commande?.TTC || 0) + Number(commande?.manutention_total_ttc || 0);

/**
 * Le détail sous le total : transport et manutention, ou l'alerte « à
 * confirmer ». Partagé par la liste et le kanban, pour qu'ils disent la même
 * chose de la même commande.
 *
 * @return {{ aConfirmer: boolean, transport: number, manutention: number } | null}
 */
export const detailTotalCommande = (commande) => {
  const transport = Number(commande?.TTC || 0);
  const manutention = Number(commande?.manutention_total_ttc || 0);
  const aConfirmer = commande?.manutention_status === "a_confirmer";

  if (!aConfirmer && manutention <= 0) return null;

  return { aConfirmer, transport, manutention };
};
